export enum ApiLpErrorResolutionPolicy {
  Safe = 'SAFE',
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export interface IApiLpErrorResolution {
  policy: ApiLpErrorResolutionPolicy;
  resetSeqNumFlagSupported: boolean;
}
